<template>
  <div :class="$style.item">
    <HeadingExtraSmall
      v-if="title"
      :class="$style.title"
    >
      {{ title }}
    </HeadingExtraSmall>
    <RadioGroup
      v-model="userPasswordExpirationAction"
      :class="$style.item"
      data-test-id="ldapPasswordExpiration"
      inline
      label="Password Expiration"
      :name="`${name}-password`"
      :options="optionsPasswordExpiration"
      :showValidationMessage="false"
    />
    <RadioGroup
      v-model="userLockoutAction"
      :class="$style.item"
      data-test-id="ldapAccountLockout"
      inline
      label="Account Lockout"
      :name="`${name}-account`"
      :options="optionsAccountLockout"
      :showValidationMessage="false"
    />
  </div>
</template>

<script>
import {
  HeadingExtraSmall,
  RadioGroup,
} from '@jumpcloud/ui-components';
import createComputedObjectBinding from 'client/util/createComputedObjectBinding';

export default {
  name: 'FieldsPasswordConfiguration',

  components: {
    HeadingExtraSmall,
    RadioGroup,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    optionsAccountLockout: {
      type: Array,
      default: () => ([]),
    },
    optionsPasswordExpiration: {
      type: Array,
      default: () => ([]),
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    userLockoutAction: {
      ...createComputedObjectBinding('userLockoutAction'),
    },

    userPasswordExpirationAction: {
      ...createComputedObjectBinding('userPasswordExpirationAction'),
    },
  },
};
</script>

<style module>
  .item:not(:last-child) {
    margin-bottom: var(--jc-spacer-medium);
  }

  .title {
    word-break: break-all;
  }
</style>
